import { css } from "styled-components";
import "@fontsource/open-sans/400.css";
import openSansCustomFont from "@fontsource/open-sans/files/open-sans-latin-600-normal.woff2";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
export const fonts = css`
    @font-face {
        font-family: "Open Sans";
        src: url(${openSansCustomFont}) format("woff2");
        font-weight: 500;
        font-style: normal;
        font-display: swap;
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329,
            U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
`;
